const pt = {
  nav: { about: "Quem somos", services: "Serviços", logistics: "Logística", clients: "Clientes", news: "Notícias", contact: "Contacto", cta: "Solicitar consultoria", menu: "Menu", close: "Fechar" },
  global: {
    eyebrow: "O mundo em movimento",
    title: "Da Costa às _grandes capitais_.",
    intro: "Pessoas que fazem negócios, mercadorias em trânsito: este é o mundo em que trabalhamos todos os dias.",
    capitals: "Grandes capitais",
    deals: "Pessoas & negócios",
    base: "A minha base: a Costa",
    ops: "Mercadorias em movimento",
    timezones: "Fusos horários",
    newsTicker: "Notícias do mundo · sempre atualizadas · leia mais abaixo em Notícias & Mercados",
  },
  news: {
    eyebrow: "06 — Notícias & Mercados",
    title: "O mundo dos transportes, _em tempo real_.",
    intro: "Manchetes atualizadas automaticamente pelos principais portais de logística internacional.",
    read: "Ler",
    updated: "Atualizado",
  },
  hero: {
    eyebrow: "Consultoria empresarial · Import Export · Logística",
    lines: ["Levamos", "as empresas", "_para lá_ das fronteiras."],
    sub: "Apoiamos as empresas na importação e exportação, nos processos documentais, na entrada em novos mercados e na logística internacional: do primeiro contacto à entrega final.",
    cta: "Vamos falar do seu projeto",
    cta2: "Ver os serviços",
    scroll: "Deslize",
    tags: ["Mar", "Ar", "Terra", "Expresso"],
    frame: "Rotas globais, um único interlocutor",
  },
  marquee: ["Import · Export", "Processos documentais", "Temperatura controlada", "Mercadorias perigosas DGR", "Transporte marítimo", "Carga aérea", "Transporte rodoviário", "Armazenagem & embalagem", "Desenvolvimento de mercados"],
  about: {
    eyebrow: "01 — Quem somos",
    title: "Um consultor, uma rede, _um método_ para crescer no estrangeiro.",
    body1: "A MF Logistics Consulting Group nasceu para dar às empresas um ponto de referência único quando decidem vender, comprar ou produzir para além das fronteiras nacionais.",
    body2: "Unimos competência documental, conhecimento dos mercados e operação logística para transformar uma ideia de expansão num fluxo real de mercadorias, contratos e relações.",
    founderRole: "Fundadora & CEO",
    founderLine: "Uma longa experiência internacional na Europa e no mundo: acompanho as empresas para lá das fronteiras, com cuidado e método.",
    doorCaption: "A minha porta está sempre aberta",
    pillars: [
      { t: "Visão de conjunto", d: "Estratégia comercial, documentos e transporte como um único projeto." },
      { t: "Operação real", d: "Acompanhamos cada expedição e cada processo até ao fim." },
      { t: "Rede de contactos", d: "Parceiros, fornecedores e compradores selecionados nos mercados de destino." },
    ],
  },
  services: {
    eyebrow: "02 — Serviços",
    title: "Consultoria à medida, _do papel_ ao contentor.",
    intro: "Cada empresa é diferente: desenhamos o caminho mais adequado à sua realidade.",
    items: [
      { t: "Import & Export", d: "Planeamento dos fluxos, Incoterms, fornecedores e parceiros logísticos para comprar e vender no estrangeiro com segurança." },
      { t: "Processos documentais", d: "Aduanas, certificados de origem, documentos de transporte e conformidade regulamentar geridos com precisão." },
      { t: "Introdução de produtos no mercado", d: "Análise do mercado-alvo, requisitos de entrada e estratégia de lançamento dos seus produtos." },
      { t: "Desenvolvimento em mercados externos", d: "Planos de internacionalização e crescimento comercial em novos países e canais." },
      { t: "Desenvolvimento de contactos", d: "Pesquisa e qualificação de compradores, distribuidores e parceiros no mercado de interesse." },
      { t: "Encomendas de mercados externos", d: "Pesquisa de clientes internacionais e gestão dos seus pedidos de encomenda, do primeiro contacto à encomenda confirmada." },
      { t: "Consultoria empresarial", d: "Apoio na organização, nos processos e em qualquer outra necessidade da sua atividade empresarial." },
    ],
  },
  logistics: {
    eyebrow: "03 — Logística",
    title: "Qualquer mercadoria, _qualquer_ rota.",
    intro: "Organizamos expedições completas para todo o tipo de mercadoria e modalidade de transporte, com armazenagem e embalagem incluídas.",
    modesTitle: "Modos de transporte",
    modesDesc: "Combinamos navio, avião, estrada e expresso para encontrar o equilíbrio certo entre tempos, custos e segurança.",
    modes: ["Navio", "Avião", "Estrada", "Expresso"],
    goodsTitle: "Tipos de mercadoria",
    goods: [
      { t: "Temperatura ambiente — General cargo", d: "Carga geral, agrupamento e cargas completas." },
      { t: "Temperatura controlada", d: "Cadeia de frio e intervalos térmicos dedicados." },
      { t: "Mercadorias perigosas DGR", d: "Gestão documental e operativa ADR / IMDG / IATA." },
    ],
    subsLabel: "Subcategorias de carga",
    subs: ["Alimentos & perecíveis (incl. congelados)", "Farmacêuticos", "Máquinas & equipamentos", "Bens de luxo", "Vestuário", "Cosméticos", "…e mais"],
    insurance: { t: "Seguro de mercadoria", d: "Proteção completa da sua carga em cada etapa." },
    docsPermits: { t: "Documentos & licenças", d: "Registos, certificados sanitários, licenças de entrada e cada prática." },
    palletControl: { t: "Paletização & controlo", d: "Armazenagem, paletização e controlo de mercadoria em armazém." },
    warehousing: { t: "Armazenagem", d: "Armazenagem, gestão de stocks e distribuição." },
    packaging: { t: "Embalagem", d: "Embalagens adequadas à mercadoria, ao modo e às normas." },
    customs: { t: "Documentos & aduana", d: "Do conhecimento de embarque ao certificado: cada papel no seu lugar." },
  },
  newsletter: {
    eyebrow: "A newsletter",
    titleAccent: "Fique atualizado",
    title: " com o mundo.",
    sub: "Todos os meses: rotas, mercados e dicas práticas para vender e comprar além-fronteiras. Sem spam.",
    placeholder: "O seu email",
    cta: "Subscrever",
    sending: "A enviar…",
    ok: "Subscrição confirmada! Irá receber as nossas notícias.",
    already: "Já está subscrito à newsletter.",
    error: "Ocorreu um erro. Tente novamente.",
    privacy: "Ao subscrever, aceita receber as nossas comunicações. Sem spam: cancele quando quiser.",
  },
  clients: {
    eyebrow: "04 — Clientes",
    title: "Empresas que escolheram _os nossos serviços_.",
    intro: "Algumas das empresas que acompanhamos nos mercados internacionais.",
    consTitle: "Com a _consultoria_.",
    impTitle: "Com o _import-export_.",
    placeholder: "[Logótipo do cliente]",
    visit: "Visitar",
  },
  contact: {
    eyebrow: "05 — Contacto",
    title: "Diga-nos _onde_ quer chegar.",
    intro: "Escreva-nos: entraremos em contacto para definir juntos o melhor caminho.",
    fields: { name: "Nome completo", company: "Empresa", email: "Email", phone: "Telefone", service: "Do que precisa?", message: "Mensagem" },
    servicePick: "Escolha um serviço",
    logisticsOption: "Expedições & logística",
    submit: "Enviar pedido",
    sending: "A enviar…",
    success: "Obrigado! Recebemos o seu pedido e entraremos em contacto em breve.",
    error: "Falha no envio. Verifique os campos e tente novamente.",
    direct: "Contacto direto",
    emailLabel: "Email",
    phoneLabel: "Telefone",
    vatLabel: "NIF/IVA",
    addressLabel: "Sede",
  },
  footer: { tagline: "Consultoria empresarial, import-export e logística internacional.", rights: "Todos os direitos reservados.", admin: "Área reservada", top: "Voltar ao topo" },
};
export default pt;
